export default "__VITE_ASSET__DvhqIcX1__"